import React from 'react';
import ReactSwitch from 'react-switch';
import { lighten } from 'polished';

import { Container } from './styles';

interface SwitchProps {
  disabled?: boolean;
  checked: boolean;
  handleChange(): void;
}

const Switch: React.FC<SwitchProps> = ({
  disabled = false,
  checked,
  handleChange,
  children,
}) => {
  return (
    <Container>
      <ReactSwitch
        checked={checked}
        onChange={handleChange}
        checkedIcon={false}
        uncheckedIcon={false}
        height={10}
        width={24}
        handleDiameter={14}
        onHandleColor="#eb0045"
        offHandleColor="#808080"
        offColor={lighten(0.3, '#808080')}
        onColor={lighten(0.3, '#eb0045')}
        disabled={disabled}
      />
      {children}
    </Container>
  );
};

export default Switch;
